import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);        
  const router = inject(Router);
  const token = authService.getToken();

  // Check if session has expired before making any API call
  if (authService.LoginStatus && !authService.isSessionValid()) {
      // Session has expired based on JWT token
      authService.logout();
      router.navigate(['/login']);
      return new Observable(subscriber => {
        subscriber.error({ status: 401, message: 'Session expired' });
      });
  }

  if (req.url.includes('/auth/login')) {
    return next(req);
  }

  let headers = req.headers
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  const modifiedReq = req.clone({ headers });

  return next(modifiedReq).pipe(
    catchError((err) => {
      if (err.status === 401 || err.status === 0) {
        authService.logout();
        router.navigate(['/login']);
      }
      throw err;
    })
  );
};
